import { render } from "./AppSelfMed.vue?vue&type=template&id=adeb09b6&scoped=true"
const script = {}

import "./AppSelfMed.vue?vue&type=style&index=0&id=adeb09b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adeb09b6"]])

export default __exports__